import { motion } from 'motion/react'
import { PlatformMarketingCard } from '../groupPlatformItems'
import { LandingSection } from '../LandingSection'

export function TerminologySection({ items }: { items: PlatformMarketingCard[] }) {
  return (
    <LandingSection className="bg-tertiary" eyebrow="Glossary" title="Terminology">
      <dl className="grid gap-8 sm:grid-cols-2 lg:grid-cols-5">
        {items.map((item, index) => (
          <motion.div
            key={item.card.id || item.card.title}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-80px' }}
            transition={{ duration: 0.45, delay: index * 0.04 }}
          >
            <dt className="font-semibold text-tertiary-foreground">{item.card.title}</dt>
            <dd className="mt-2 text-sm leading-relaxed text-muted-foreground">{item.card.subtitle}</dd>
          </motion.div>
        ))}
      </dl>
    </LandingSection>
  )
}
